import React, {useEffect, useMemo, useState} from "react";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {
    fetchAdvancedTypesBuys, fetchBankAccounts,
    fetchBuysGeneralSettings,
    fetchCashRegisters,
    putSupplier,
} from "../../../../_apis/api";
import EditableTable from "../../../primer/Editable-Table";
import {useDispatch, useSelector} from "react-redux";
import {
    buysMyDataStatus, getCountryOptions,
    getCurrentUser,
    getDefaultOptionByValue,
    getDOYOptions,
    getEmployeeCategoryOptions,
    getEmployeeTypeOptions,
    getGreekCurrencyFormat,
    getInstallationsTypes,
    getOptionsByData,
    getVatCategoryOptions,
    isEmpty, quickClone,
} from "../../../../_helpers/commonFunctions";
import {setSaveBuys} from "../../../../_reducers/activitySlice";
import {
    deleteObjectFromArrayOfObjects, fixDocumentTaxesDisplay,
    getLabelByValue,
    getObjectFromArrayOfObjects
} from "../../../../_helpers/helperFunctions";
import {
    newBuysInitialValue,
    setNewBuyAutofill,
    setNewBuys,
    setNewBuysExtraData,
    setNewBuysNewProduct,
    setNewBuySupplierCustomData
} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import TextArea from "../../../common/TextArea";
import {toast} from "react-toastify";
import getMyData, {getSpecialCategoryOptions} from "../../../../_helpers/sharedmydata";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewSupplierModal from "../Suppliers/new-supplier-modal";
import {
    getBuysTaxesData,
    getBuysTotals,
    getDiscountExclusiveVat,
    getNetValue,
    getNetValueByTotalValue,
    getPriceExclusiveVat,
    getProductFee,
    getProductOtherTax,
    getProductStamp,
    getProductWithholdTax,
    getTaxes,
    getTotalValue,
    getUnitPrice,
    getVatPercent,
    getVatValue,
    parseNumber
} from "../../../../_helpers/product-buys-calculations";
import {vatCategoryData} from "../../../../_data/mydata/vatCategory";
import moment from "moment";
import HourPicker from "../../../primer/HourPicker";
import QuickEdit from "../../../primer/QuickEdit";
import {getOtherCorrelatedEntitiesTypes} from "../../../../_data/mydata/otherCorrelatedEntities";
import OtherCorrelatedEntitiesModal from "../../../primer/POPUP-COMPONENTS/otherCorrelatedEntitiesModal";
import AccountingBox from "../../../primer/AccountingBox";
import {receivingNotePurposeOptions} from "../../../../_data/mydata/receivingNotePurposes";
import {useTranslation} from "../../../../hooks/useTranslation";
import BetterCheckBox from "../../../common/BetterCheckBox";

const apiURL2 = process.env.REACT_APP_API_URL2;

const BuysNew = ({lockPaymentType = false}) => {
    const {t} = useTranslation();
    let date = new Date();
    const currentTime = date.getHours() + ':' + String(date.getMinutes()).padStart(2, '0');
    const dispatch = useDispatch();
    const saveBuys = useSelector((state) => state.ACTIVITY.saveBuys);
    const BUYS = useSelector((state) => state.BUYS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const newBuyAutofill = useSelector((state) => state.BUYS.newBuyAutofill);

    const buysGeneralSettings = useSelector((state) => state.BUYS_SETTINGS.buysGeneralSettings);
    const bankAccounts = useSelector((state) => state.CASH_DATA.bankAccounts);
    const cashRegisters = useSelector((state) => state.CASH_DATA.cashRegisters);

    const newBuySupplierCustomData = useSelector((state) => state.BUYS.newBuySupplierCustomData);
    const supplierVatCategory = newBuySupplierCustomData.supplierVatCategory;
    const supplierVatReason = newBuySupplierCustomData.supplierVatReason;
    const supplierCustomVat = newBuySupplierCustomData.supplierCustomVat;

    const bankData = bankAccounts.filter((bankAccount) => bankAccount.isActive === "active");
    const bankOptions = [{value: "", label: "Κενό"}, ...getOptionsByData(bankData, '_id', 'name')];
    const selectedPaymentType = buysGeneralSettings?.paymentTypes ? buysGeneralSettings?.paymentTypes?.find((el) => el._id === BUYS.newBuys?.paymentType) : null;
    const showBankSelection = selectedPaymentType ? ["bank-account", "bank-account-outside", "web-banking", "pos"].includes(selectedPaymentType.type) : false;
    const requiredBankAccount = selectedPaymentType ? selectedPaymentType?.options?.autopayment === "active" : false;

    const canHaveOtherCorrelations = !isEmpty(BUYS.newBuys?.myDataType) && ["10.1"].includes(BUYS.newBuys?.myDataType) && !isEmpty(BUYS.newBuys?.supplier);
    const [otherCorrelatedInvoicesDefaultData, setOtherCorrelatedInvoicesDefaultData] = useState([]);

    const [selectedEntity, setSelectedEntity] = useState(null);

    const requestData = {
        company: company.id
    };
    const currentUser = getCurrentUser();
    const requestData2 = {
        company: company.id,
        year: company.year.toString(),
        isActive: "active",
        userId: currentUser.id
    }
    const productCodeColumns = [
        {
            label: t("General.code"),
            name: "code",
        },
        {
            label: t("General.alternateCode"),
            name: "alternateCode",
        },
        {
            label: t("General.productName"),
            name: "name",
        },
        {
            label: t("General.alternateName"),
            name: "alternateName",
        },
    ];

    const supplierDropdownColumns = [
        {
            label: t("General.code"),
            name: "systemCode",
        },
        {
            label: t("General.supplierName"),
            name: "name",
        },
        {
            label: t("General.phone"),
            name: "phone",
        },
        {
            label: t("General.email"),
            name: "email",
        },
        {
            label: t("General.vatNumber"),
            name: "vatNumber",
        },
    ];

    const employeeDropdownColumns = [
        {
            label: "Όνομα",
            name: "firstName",
        },
        {
            label: "Επώνυμο",
            name: "lastName",
        },
        {
            label: "Α.Φ.Μ.",
            name: "vatNumber",
        },
        {
            label: "Τηλέφωνο",
            name: "phone",
        }
    ];
    const supplierInstallationsDropdownColumns = [
        {
            label: t("General.type"),
            name: "type",
        },
        {
            label: t("General.address"),
            name: "address",
        }
    ];
    const [activeTab, setActiveTab] = useState(0);
    const [showCateogryConfirmation, setShowCateogryConfirmation] = useState(false);
    const [tempCatValue, setTempCatValue] = useState({});
    const [showProductTableSpinner, setProductTableSpinner] = useState('false');
    const [buysProductList, setBuysProductList] = useState([]);
    const [suppliersListData, setSuppliersListData] = useState([]);
    const [employeeListData, setEmployeeListData] = useState([]);
    const [supplierInstallationListData, setSupplierInstallationListData] = useState([]);
    const [pRequestData, setPRequestData] = useState({});
    const [updateBuyAmounts, setUpdateBuyAmounts] = useState(false);
    const installations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const installationOptions = getOptionsByData(installations, "installationMasterId", "address");

    const fetchOtherCorrelatedInvoicesData = (keyword, setData, forceSupplier) => {
        if (canHaveOtherCorrelations) {
            const requestData = {
                company: company.id,
                year: company.year,
                supplier: BUYS.newBuys.supplier,
                myDataType: BUYS.newBuys.myDataType,
            }
            if (!isEmpty(keyword)) requestData.keyword = keyword;
            if (!isEmpty(forceSupplier)) requestData.supplier = forceSupplier;
            axios.post(apiURL2 + "/buy/other-correlated-invoices-list", requestData, {
                headers: { 'Content-Type': 'application/json'}
            }).then((res) => {
                if (res.data.status === "200") {
                    if (setData) setData(res.data.data);
                } else {
                    if (setData) setData([]);
                }
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    useEffect(() => {
        if (canHaveOtherCorrelations) {
            fetchOtherCorrelatedInvoicesData(null, setOtherCorrelatedInvoicesDefaultData, BUYS.newBuys.supplier);
        }
    }, [canHaveOtherCorrelations])

    const manageAutofill = async (autofillData) => {
        if (autofillData) {
            let currentBuyState = quickClone(newBuysInitialValue);
            if (autofillData.documentType) {
                currentBuyState = await handleOnChange({
                    value: autofillData.documentType,
                    label: autofillData.documentTypeName,
                }, "dd", "documentType", currentBuyState);
            }
            if (autofillData.supplier) {
                currentBuyState = await handleOnChange({
                    value: null,
                    row: autofillData.supplier,
                }, "acdd", "supplier", currentBuyState);
            }
            if (autofillData.otherCorrelatedInvoices) currentBuyState.otherCorrelatedInvoices = autofillData.otherCorrelatedInvoices;

            dispatch(setNewBuys(currentBuyState));
            dispatch(setNewBuyAutofill(null));
        }
    }

    useEffect(() => {
        if (newBuyAutofill) manageAutofill(newBuyAutofill);
    }, [newBuyAutofill])

    const [incrKey3, setIncrKey3] = useState(0);
    useEffect(() => {
        setIncrKey3(incrKey3 + 1);
    }, [BUYS.newBuys?.otherCorrelatedInvoices, otherCorrelatedInvoicesDefaultData])

    useEffect(() => {
        dispatch(fetchAdvancedTypesBuys(requestData));
        dispatch(fetchBuysGeneralSettings(requestData2));
        dispatch(fetchBankAccounts(requestData2));
        dispatch(fetchCashRegisters(requestData2));
    }, []);

    useEffect(() => {
        if (BUYS.newBuys.documentType !== "") {
            loadSuppliersListData(BUYS.newBuys.documentType);
            loadProductListData(BUYS.newBuys.documentType);
        }
    }, [])

    useEffect(() => {
        // Load Product based on selected advanced type if my data rule applies
        if (BUYS.newBuys.documentType !== "") {
            loadSuppliersListData(BUYS.newBuys.documentType);
            loadProductListData(BUYS.newBuys.documentType);
        }
    }, [BUYS.newBuys.installation])

    const [incrKey, setIncrKey] = useState(0);
    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [BUYS.newBuys.products, buysProductList])

    let pMDDSettings = SETTINGS.primerMyDataData;
    const documentTypesOptions = useMemo(() => getOptionsByData(SETTINGS.settings.advancedTypesBuys, "_id", "name"), [SETTINGS.settings.advancedTypesBuys]);
    const waysOfSendingGoodsOptions = useMemo(() => [{value: "", label: t("General.empty")}, ...getOptionsByData(buysGeneralSettings.sendingGoods, "_id", "name")], [buysGeneralSettings.sendingGoods]);
    const carNumbersOptions = useMemo(() => [{value: "", label: t("General.empty")}, ...getOptionsByData(buysGeneralSettings.carNumbers, "_id", "number")], [buysGeneralSettings.carNumbers]);
    const paymentTypeOptions = useMemo(() => getOptionsByData(buysGeneralSettings.paymentTypes, "_id", "name"), [buysGeneralSettings.paymentTypes]);
    let otherTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.otherTaxes !== undefined && pMDDSettings?.otherTaxes !== '' ? pMDDSettings.otherTaxes.filter(otherTax => otherTax.taxPer === "true" && otherTax.taxLevel === 1) : SETTINGS.otherHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.otherHoldTaxes]);
    let withHoldTaxesOptions = useMemo(() => getOptionsByData(pMDDSettings?.withHoldTaxes !== undefined && pMDDSettings?.withHoldTaxes !== '' ? pMDDSettings.withHoldTaxes.filter(withHoldTax => withHoldTax.taxPer === "true" && withHoldTax.taxLevel === 1) : SETTINGS.withHoldTaxes, 'code', 'name'), [pMDDSettings, SETTINGS.withHoldTaxes]);
    let stampOptions = useMemo(() => getOptionsByData(pMDDSettings?.stamp !== undefined && pMDDSettings?.stamp !== '' ? pMDDSettings.stamp.filter(stamp => stamp.taxPer === "true" && stamp.taxLevel === 1) : SETTINGS.stamp, 'code', 'name'), [pMDDSettings, SETTINGS.stamp]);
    let feesOptions = useMemo(() => getOptionsByData(pMDDSettings?.fees !== undefined && pMDDSettings?.fees !== '' ? pMDDSettings.fees.filter(fee => fee.taxPer === "true" && fee.taxLevel === 1) : SETTINGS.fees, 'code', 'name'), [pMDDSettings, SETTINGS.fees]);
    otherTaxesOptions = [{value: "", label: t("General.empty"), color: "#76AEB7"}, ...otherTaxesOptions];
    withHoldTaxesOptions = [{value: "", label: t("General.empty"), color: "#76AEB7"}, ...withHoldTaxesOptions];
    stampOptions = [{value: "", label: t("General.empty"), color: "#76AEB7"}, ...stampOptions];
    feesOptions = [{value: "", label: t("General.empty"), color: "#76AEB7"}, ...feesOptions];
    const measurementUnitOptions = getMyData({type: 'mu', settings: SETTINGS});
    const buysMyDataStatusOptions = buysMyDataStatus();
    const specialInvoiceCategoryOptions = getSpecialCategoryOptions("");
    const [requiredPaymentType, setRequiredPaymentType] = useState(false);
    let disabledFields = false;
    if (BUYS.newBuys.documentType === undefined || BUYS.newBuys.documentType === '') {
        disabledFields = true;
    }
    const supplierProductsColumns = [
        {
            name: t("General.no"),
            field: "no",
            width: "40px",
            editable: false,
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.productCode"),
            field: "code",
            width: "130px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: buysProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t("Placeholders.selectProductCode")
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t("General.productName"),
            field: "name",
            width: "400px",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: productCodeColumns,
                    data: buysProductList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: t("Placeholders.selectProductName")
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: t("General.quantity"),
            field: "quantity",
            width: "100px",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    maxLength: 10,
                    allowNegative: BUYS.newBuys?.myDataType === "10.1",
                }
            }
        },
        {
            name: t("General.measurementUnit"),
            field: "muLabel",
            editable: false,
            width: "60px",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.unitPrice"),
            field: "unitPrice",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t("General.discount"),
            field: "discount",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: "%",
            field: "isPerDiscount",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                name: 'discountType',
                radioLogic: 'oneperrow',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: "€",
            field: "isDiscountAmount",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'radio',
                radioLogic: 'oneperrow',
                name: 'discountType',
                options: [{
                    value: true,
                    label: 'True'
                }, {
                    value: false,
                    label: 'False'
                }]
            }
        },
        {
            name: t("General.vatPercentage"),
            field: "vatPercentage",
            inputType: {
                type: 'text',
            }
        },
        {
            name: t("General.netValue"),
            field: "netValue",
            editable: buysGeneralSettings?.forbitChange !== "active",
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t("General.vatValue"),
            field: "vat",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t("General.taxes"),
            field: "taxes",
            editable: false,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
        {
            name: t("General.totalValue"),
            field: "totalValue",
            editable: true,
            inputType: {
                type: 'accounting',
                config: {
                    suffix: "€",
                    maxLength: 10
                }
            }
        },
    ]

    const handleConfirmCategory = async () => {
        // Populate Selected Category Data
        let newBuysData = {};
        let value = tempCatValue.new;
        newBuysData.documentType = value;
        newBuysData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
        const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesBuys, value, "_id");
        if (selectedDocumentTypeData.length > 0) {
            let selectedDTData = selectedDocumentTypeData['0'];
            newBuysData.myDataType = selectedDTData.myDataType?.toString();
            if (newBuysData?.myDataType === "17.1") {
                newBuysData.supplierType = "Employee";
            } else {
                newBuysData.supplierType = "Existing";
            }
            // This applies only if selected check box is tick in the table.
            newBuysData.installation = selectedDTData?.proposedInstallation;
            newBuysData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
            if (selectedDTData?.vatPaymentSuspension === "active") {
                newBuysData.vatPaymentSuspension = true;
            } else {
                newBuysData.vatPaymentSuspension = undefined;
            }
            if (selectedDTData?.receivingNotePurpose) newBuysData.receivingNotePurpose = selectedDTData.receivingNotePurpose;
            if (selectedDTData?.otherReceivingNotePurposeTitle) newBuysData.otherReceivingNotePurposeTitle = selectedDTData.otherReceivingNotePurposeTitle;

            loadProductListData(value);
            if (newBuysData?.myDataType === "17.1") {
                loadEmployeeListData(value);
            } else {
                loadSuppliersListData(value);
            }
            // Load Product based on selected advanced type if my data rule applies
            // Clear Product List on change
            newBuysData.products = [];
            //Clear Supplier
            newBuysData.supplier = "";
            newBuysData.supplierName = "";
            newBuysData.supplierCode = "";
            newBuysData.address = "";
            newBuysData.vat = "";
            newBuysData.doy = "";
            newBuysData.city = "";
            newBuysData.supplierCategoryName = "";
            newBuysData.supplierCategory = "";
            newBuysData.country = "";
            newBuysData.pc = "";
            newBuysData.email = "";
            newBuysData.phone = "";
            newBuysData.activity = "";
            newBuysData.vatCategory = "";
            setSupplierInstallationListData([]);
            newBuysData.supplierInstallationType = "";
            newBuysData.supplierInstallationId = "";
            dispatch(setNewBuySupplierCustomData({
                supplierVatCategory: "Normal VAT",
                supplierVatReason: "",
                supplierCustomVat: 0,
            }))
        }
        dispatch(setNewBuys({...BUYS.newBuys, ...newBuysData}));
        setShowCateogryConfirmation(false);
    }

    const loadSuppliersListDataOnChange = (value, setData) => {
        let data = {
            id: BUYS.newBuys.documentType,
            name: value,
            company: company.id
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/supplier-list-by-advanced-type-id/${data.id}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        // Remove none empty supplier name data
                        let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
                        setData(filteredData);
                    } else {
                        setData([]);
                    }
                } else {
                    setData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }
    const onChangeSearch = (keyword, setData) => {
        if (keyword.length >= 2) {
            loadSuppliersListDataOnChange(keyword, setData)
        }
    }

    const loadSuppliersListData = (value) => {
        const data = {
            id: value,
            company: company.id,
            name: ''
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/supplier-list-by-advanced-type-id/${value}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        // Remove none empty supplier name data
                        let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
                        setSuppliersListData([...filteredData]);
                    } else {
                        setSuppliersListData([]);
                    }
                } else {
                    setSuppliersListData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }

    const loadEmployeeListData = (value) => {
        const data = {
            id: value,
            company: company.id,
            name: ''
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/supplier/supplier-list-by-advanced-type-id/${value}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        // Remove none empty supplier name data
                        let filteredData = deleteObjectFromArrayOfObjects(res.data.data, '', 'name');
                        setEmployeeListData([...filteredData]);
                    } else {
                        setEmployeeListData([]);
                    }
                } else {
                    setEmployeeListData([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }

    const loadProductListData = (value) => {
        let data = {
            id: value,
            name: '',
            company: company.id
        }
        setPRequestData({...data})
        axios.get(process.env.REACT_APP_API_URL2 + `/buy/product-list-by-advanced-type-id/${data.id}`, {params: data})
            .then(res => {
                if (res.data && res.data.status === '200') {
                    if (res.data.data) {
                        setBuysProductList(res.data.data);
                    } else {
                        setBuysProductList([]);
                    }
                } else {
                    setBuysProductList([]);
                }
            }).catch((err) => {
            console.log(err);
        })
    }

    const handleOnChange = async (e, type = "default", ddname = '', currentBuyState = null) => {
        // Set if editing the form
        if (!saveBuys) dispatch(setSaveBuys(true));

        let name;
        let value = '';
        if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'acdd') {
            e = e.row;
            value = e._id;
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }

        let buysData = currentBuyState ? currentBuyState : Object.assign({}, BUYS.newBuys);
        let newBuysData = {};
        if (name === "time") {
            if (value !== currentTime && value !== null) {
                newBuysData.customTime = "true";
            }
        }
        if (name === "date") {
            if (value !== date && value !== null) {
                newBuysData.customTime = "true";
            }
        }
        if (name === 'documentType' && buysData.documentType !== value) {
            if (buysData.documentType !== "") {
                // Show confirmation before category change.
                setShowCateogryConfirmation(true);
                setTempCatValue({e: e, new: value, old: buysData.documentType});
            } else {
                // Populate Selected Category Data
                newBuysData[name] = value;
                newBuysData.documentTypeName = getLabelByValue(documentTypesOptions, value, 'value');
                const selectedDocumentTypeData = getObjectFromArrayOfObjects(SETTINGS.settings.advancedTypesBuys, value, "_id");
                if (selectedDocumentTypeData.length > 0) {
                    let selectedDTData = selectedDocumentTypeData['0'];
                    newBuysData.myDataType = selectedDTData.myDataType?.toString();
                    newBuysData.installation = selectedDTData?.proposedInstallation;
                    newBuysData.specialInvoiceCategory = selectedDTData?.specialInvoiceCategory ? selectedDTData.specialInvoiceCategory : "";
                    if (selectedDTData?.vatPaymentSuspension === "active") {
                        newBuysData.vatPaymentSuspension = true;
                    } else {
                        newBuysData.vatPaymentSuspension = undefined;
                    }
                    if (selectedDTData?.receivingNotePurpose) newBuysData.receivingNotePurpose = selectedDTData.receivingNotePurpose;
                    if (selectedDTData?.otherReceivingNotePurposeTitle) newBuysData.otherReceivingNotePurposeTitle = selectedDTData.otherReceivingNotePurposeTitle;

                    if (newBuysData?.myDataType === "17.1") {
                        newBuysData.supplierType = "Employee";
                    } else {
                        newBuysData.supplierType = "Existing";
                    }
                    // Load Product based on selected advanced type if my data rule applies
                    if (selectedDTData.enableMyDataRules && selectedDTData.enableMyDataRules === 'active') {
                        loadProductListData(value);
                        loadSuppliersListData(value);
                        setRequiredPaymentType(true);
                    }
                }
            }
        } else {
            newBuysData[name] = value;
        }
        if (name === 'supplier') {
            if (canHaveOtherCorrelations) {
                fetchOtherCorrelatedInvoicesData(null, setOtherCorrelatedInvoicesDefaultData, value);
            }
            let selectedSupplier = getObjectFromArrayOfObjects(suppliersListData, value, '_id');
            await axios.get(apiURL2 + `/supplier/get-supplier-id-by/${value}`)
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        selectedSupplier['0'] = res.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                })
            if (selectedSupplier.length > 0) {
                let sSupplier = selectedSupplier['0'];
                newBuysData.supplierName = sSupplier.name;
                newBuysData.supplierCode = !isEmpty(sSupplier.manualCode) ? sSupplier.manualCode : sSupplier.systemCode;
                newBuysData.address = sSupplier.address;
                newBuysData.vat = sSupplier.vatNumber;
                newBuysData.doy = getLabelByValue(getDOYOptions(), Number(sSupplier.DOY), 'value');
                newBuysData.city = sSupplier.city;
                newBuysData.supplierCategoryName = sSupplier?.categoryName;
                newBuysData.supplierCategory = sSupplier?.category;
                newBuysData.country = sSupplier.country;
                newBuysData.pc = sSupplier.postalCode;
                newBuysData.email = sSupplier.email;
                newBuysData.phone = sSupplier.phone;
                newBuysData.activity = sSupplier.activity;
                newBuysData.vatCategory = sSupplier.vatCategory;
                sSupplier.installations.map(installation => {
                    installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                    return installation;
                })
                setSupplierInstallationListData(sSupplier.installations);
                newBuysData.supplierInstallationType = sSupplier.installations[0]?.type;
                newBuysData.supplierInstallationId = sSupplier.installations[0]?.no;
                // Set Supplier Vat Category used for product vat calculation
                dispatch(setNewBuySupplierCustomData({
                    supplierVatCategory: sSupplier?.vatCategory ? sSupplier.vatCategory : "Normal VAT",
                    supplierVatReason: sSupplier?.vatReason ? sSupplier.vatReason : "",
                    supplierCustomVat: sSupplier?.customVat ? sSupplier.customVat : 0,
                }))
            }
        }
        if (name === "employee") {
            let selectedEmployee = getObjectFromArrayOfObjects(employeeListData, value, '_id');
            await axios.get(apiURL2 + `/supplier/get-supplier-id-by/${value}`)
                .then((res) => {
                    if (res.data && res.data.status === "200") {
                        selectedEmployee['0'] = res.data.data;
                    }
                }).catch((err) => {
                    console.log(err);
                })
            if (selectedEmployee.length > 0) {
                let sEmployee = selectedEmployee['0'];
                newBuysData.employeeName = sEmployee.firstName + " " + sEmployee.lastName;
                newBuysData.vat = sEmployee.vatNumber;
                newBuysData.employeeType = sEmployee.employeeType;
                newBuysData.employeeCategory = sEmployee.employeeCategory;
                newBuysData.phone = sEmployee.phone;
            }
        }
        if (name === 'supplierInstallation') {
            let selectedSupplierInstallation = "";
            supplierInstallationListData.map(installation => {
                if (value === installation._id) {
                    selectedSupplierInstallation = installation;
                }
                return installation;
            })
            if (selectedSupplierInstallation !== "") {
                newBuysData.supplierInstallationType = selectedSupplierInstallation.type;
                newBuysData.supplierInstallationId = selectedSupplierInstallation.no;
                newBuysData.address = selectedSupplierInstallation.address;
                newBuysData.doy = getLabelByValue(getDOYOptions(), Number(selectedSupplierInstallation.DOY), 'value');
                newBuysData.city = selectedSupplierInstallation.city;
                newBuysData.pc = selectedSupplierInstallation.postalCode;
            }
        }
        if (name === 'paymentType') {
            newBuysData.paymentTypeName = getLabelByValue(paymentTypeOptions, value, 'value');
            // This will update the pre-selected POS / Bank
            let paymentTypesData = getObjectFromArrayOfObjects(buysGeneralSettings.paymentTypes, value, '_id');
            if (paymentTypesData && paymentTypesData.length > 0) {
                let selectedPaymentType = paymentTypesData['0'];
                newBuysData.myDataPaymentId = selectedPaymentType?.myDataPaymentId;
                if (selectedPaymentType?.type === "pos") {
                    newBuysData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }
                if (selectedPaymentType?.type === "bank-account" || selectedPaymentType?.type === "bank-account-outside" || selectedPaymentType?.type === "web-banking") {
                    newBuysData.bankAccount = selectedPaymentType.options?.preSelectedPosBankAccount;
                }
                if (selectedPaymentType?.type === "cash") {
                    newBuysData.bankAccount = "";
                }
            }
        }
        // Update Installation Field Values on Change
        if (name === 'installation') {
            newBuysData.installationName = getLabelByValue(installationOptions, value, 'value');
        }
        if (name === "date") {
            newBuysData['date'] = new Date(value);
        }
        if (currentBuyState) {
            return {...currentBuyState, ...newBuysData}
        } else {
            dispatch(setNewBuys({...buysData, ...newBuysData}));
        }
    }

    const handleOnChangeExtraData = (e, type = "default", ddname = '') => {
        if (!saveBuys) dispatch(setSaveBuys(true));

        let name;
        let value;

        if (type === "acb") {
            value = e.target.value;
            name = ddname;
        } else if (type === 'dd' || type === 'ac') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === "cb") {
            value = String(e.target.checked);
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
        }

        let extraData = {...BUYS.newBuys.extraData};
        extraData[name] = value;

        if (name === 'wayOfSendingGoods') {
            extraData.wayOfSendingGoodsName = getLabelByValue(waysOfSendingGoodsOptions, value, 'value');
        }
        if (name === 'carNumber') {
            extraData.carNumberName = getLabelByValue(carNumbersOptions, value, 'value');
        }
        if (name === 'otherTax') {
            extraData.otherTax = value;
        }
        if (name === 'withHoldTax') {
            extraData.withHoldTax = value;
        }
        if (name === 'fee') {
            extraData.fee = value;
        }
        if (name === 'stamp') {
            extraData.stamp = value;
        }
        let productTotals = getBuysTotals(BUYS.newBuys.products, SETTINGS);
        let productBuysTaxes = getBuysTaxesData(BUYS.newBuys.products, extraData, productTotals, SETTINGS);
        productBuysTaxes.map((buysTax) => {
            if (buysTax.vatPercentage === "Invoice Level Tax") {
                extraData.withHoldTaxEuro = buysTax.withholdTaxes;
                extraData.otherTaxEuro = buysTax.otherTaxes;
                extraData.feeEuro = buysTax.fees;
                extraData.stampEuro = buysTax.stamp;
            }
            return buysTax;
        })
        let totalTaxes = 0;
        let withHoldTaxes = 0;
        let deductions = 0;
        if (productBuysTaxes.length > 0 && productBuysTaxes[0].vatPercentage === "Invoice Level Tax") {
            totalTaxes = parseFloat((Number(productBuysTaxes[0].otherTaxes) + Number(productBuysTaxes[0].fees) + Number(productBuysTaxes[0].stamp)).toString());
            withHoldTaxes = parseFloat(productBuysTaxes[0].withholdTaxes).toFixed(2);
            deductions = parseFloat(productBuysTaxes[0].deductions).toFixed(2);
        }
        if (totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0) {
            productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
            productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
        }
        dispatch(setNewBuys({...BUYS.newBuys, buysTaxes: productBuysTaxes, ...productTotals, extraData: extraData}));
        //dispatch(setNewBuysExtraData(extraData));
    }

    const quickSupplierFields = [
        {
            name: "Supplier Name",
            field: "name",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Vat Category",
            field: "vatCategory",
            editable: true,
            inputType: {
                options: getVatCategoryOptions(),
                type: 'select',
            }
        },
        {
            name: "Vat Number",
            field: "vatNumber",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Phone Number",
            field: "phone",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Email",
            field: "email",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "Address",
            field: "address",
            editable: true,
            inputType: {
                type: "text",
            },
        },
        {
            name: "City",
            field: "city",
            editable: true,
            inputType: {
                type: "text",
            },
        },
    ];

    const newCorrelatedEntitiesTab = {
        tabName: "Λοιπές Συσχετιζόμενες Οντότητες",
        tabData: (
            <React.Fragment>
                <Row>
                    <Col md={3}>
                        <Button size={"sm"} onClick={() => setSelectedEntity({
                            id: (BUYS.newBuys.otherCorrelatedEntities.length + 1),
                            type: "new",
                            country: "GR",
                            name: "",
                            address: "",
                            city: "",
                            postalCode: "",
                            vatNumber: ""
                        })}>Προσθήκη νέας οντότητας</Button>
                    </Col>
                </Row>
                {BUYS.newBuys?.otherCorrelatedEntities?.length > 0 && (
                    <Row className="mt-3">
                        {BUYS.newBuys.otherCorrelatedEntities.map((entity, idx) => (
                            <Col md={4} className="mb-3" key={idx + "entity"} onClick={() => setSelectedEntity(entity)}>
                                <div className={"subscription-box subscription-box-permission"}>
                                    <div style={{margin: "10px"}}>
                                        <span style={{fontWeight: "600"}}>Τύπος: </span>{getOtherCorrelatedEntitiesTypes.find((el) => String(el.value) === String(entity?.type))?.label}<br/>
                                        <span style={{fontWeight: "600"}}>Επωνυμία: </span> {entity.name}<br/>
                                        <span style={{fontWeight: "600"}}>Α.Φ.Μ.: </span> {entity.vatNumber}<br/>
                                        <span style={{fontWeight: "600"}}>Χώρα: </span> {getCountryOptions('all').find((el) => String(el.value) === String(entity?.country))?.label}<br/>
                                        {entity?.address && (<><span style={{fontWeight: "600"}}>Διεύθυνση: </span> {entity.address}, {entity.city}, {entity.postalCode}<br/></>)}
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                )}
            </React.Fragment>
        )
    }

    const buysProductListActions = {
        insert: async (e, data) => {
            setProductTableSpinner('true');
            if (!saveBuys) dispatch(setSaveBuys(true));

            let productData = null;
            // Get Product By Code
            if (data && data?.field === 'code') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.value)}`, {params: company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            // Get Product By Name
            if (data && data?.field === 'name') {
                await axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.value)}`, {params: company})
                    .then(res => {
                        if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                            productData = res.data.data['0'];
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
            }
            if (productData !== null && Object.keys(productData).length > 0) {
                if (e.key !== "Enter") {
                    let tempNewProduct = Object.assign({}, BUYS.newBuysNewProduct);
                    if (productData?.showAlternativeNameOnPrint === "true") {
                        tempNewProduct.showAlternativeNameOnPrint = "true";
                        tempNewProduct.alternativeName = productData.alternateName;
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        tempNewProduct.showAlternativeCodeOnPrint = "true";
                        tempNewProduct.alternativeCode = productData.alternateCode;
                    }
                    if (productData?.specialOption) {
                        tempNewProduct.specialOption = productData.specialOption;
                    } else {
                        tempNewProduct.specialOption = undefined;
                    }
                    if (!isEmpty(productData?.permanentAnamorfosiPercent)) {
                        tempNewProduct.permanentAnamorfosiPercent = productData.permanentAnamorfosiPercent;
                    }
                    tempNewProduct.name = productData?.name;
                    tempNewProduct.code = productData?.code;
                    tempNewProduct.quantity = 1;
                    tempNewProduct.mu = productData?.measurementUnit;
                    tempNewProduct.muLabel = getLabelByValue(measurementUnitOptions, productData?.measurementUnit.toString(), 'value');
                    tempNewProduct.discount = 0;
                    tempNewProduct.taxes = 0;
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        tempNewProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    tempNewProduct.isPerDiscount = "false";
                    tempNewProduct.isDiscountAmount = "true";

                    if (String(productData?.vatIncludedBuy) === "true") {
                        const price = parseFloat(productData.buyPrice);
                        const vat = isNaN(productData.vat) ? 0 : parseFloat(productData.vat);
                        if (vat > 0) {
                            tempNewProduct.unitPrice = Number(Number(price / (1 + vat / 100)).toFixed(2));
                        } else {
                            tempNewProduct.unitPrice = parseNumber(productData.buyPrice);
                        }
                    } else {
                        tempNewProduct.unitPrice = !isEmpty(productData.buyPrice) ? parseNumber(productData.buyPrice) : 0;
                    }

                    tempNewProduct[data.field] = data.value; // Updates from table edit
                    if (data.field === 'isPerDiscount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "true";
                        tempNewProduct.isDiscountAmount = "false";
                    }
                    if (data.field === 'isDiscountAmount' && (data.value === "on" || data.value === "true")) {
                        tempNewProduct.isPerDiscount = "false";
                        tempNewProduct.isDiscountAmount = "true";
                    }
                    // Fix for loading calculation on insert
                    let discountType = 'euro';
                    if (tempNewProduct.isPerDiscount === 'true') {
                        discountType = 'per';
                    }
                    const myDataData = productData.mydata.filter(myData => String(myData.invoiceType) === BUYS.newBuys.myDataType?.toString() && myData.rowType === "expense");
                    if (productData?.isTaxLine === "true") {
                        tempNewProduct.vatPercentage = getVatPercent(supplierVatCategory, productData.vat, supplierCustomVat);
                        tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        tempNewProduct.vatReason = supplierVatReason !== "" ? supplierVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct?.vatType);
                        tempNewProduct.discount = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct?.vatType, discountType);
                        tempNewProduct.netValue = 0;
                        tempNewProduct.withHoldTax = productData.withholdTax;
                        tempNewProduct.otherTax = productData.otherTaxes;
                        tempNewProduct.stamp = productData.stamp;
                        tempNewProduct.fee = productData.fee;
                        tempNewProduct._id = productData._id;
                        tempNewProduct.isTaxLine = productData.isTaxLine;
                        if (myDataData[0]) {
                            tempNewProduct.classificationCategory = myDataData[0].category;
                            tempNewProduct.classificationType = myDataData[0].type;
                            tempNewProduct.vatExpenseType = myDataData[0].vatExpenseType;
                        } else {
                            tempNewProduct.classificationCategory = '';
                            tempNewProduct.classificationType = '';
                            tempNewProduct.vatExpenseType = '';
                        }
                        tempNewProduct.isTaxLineWithoutVat = productData.isTaxLineWithoutVat;
                        tempNewProduct.taxes = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.otherTaxEuro = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro = getProductStamp(tempNewProduct, SETTINGS);
                        tempNewProduct.vat = getVatValue(tempNewProduct.taxes, tempNewProduct.vatPercentage);
                        tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                    } else {
                        tempNewProduct.vatPercentage = getVatPercent(supplierVatCategory, productData.vat, supplierCustomVat);
                        tempNewProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        tempNewProduct.vatReason = supplierVatReason !== "" ? supplierVatReason : productData?.vatReason;
                        tempNewProduct.unitPrice = getPriceExclusiveVat(tempNewProduct.unitPrice, tempNewProduct?.vatPercentage, tempNewProduct?.vatType);
                        tempNewProduct.discount = getDiscountExclusiveVat(tempNewProduct.discount, tempNewProduct?.vatPercentage, tempNewProduct?.vatType, discountType);
                        tempNewProduct.netValue = getNetValue(tempNewProduct.unitPrice, tempNewProduct.quantity, tempNewProduct.discount, discountType);
                        tempNewProduct.withHoldTax = productData.withholdTax;
                        tempNewProduct.otherTax = productData.otherTaxes;
                        tempNewProduct.stamp = productData.stamp;
                        tempNewProduct.fee = productData.fee;
                        tempNewProduct._id = productData._id;
                        if (myDataData[0]) {
                            tempNewProduct.classificationCategory = myDataData[0].category;
                            tempNewProduct.classificationType = myDataData[0].type;
                            tempNewProduct.vatExpenseType = myDataData[0].vatExpenseType;
                        } else {
                            tempNewProduct.classificationCategory = '';
                            tempNewProduct.classificationType = '';
                            tempNewProduct.vatExpenseType = '';
                        }
                        tempNewProduct.taxes = getTaxes(tempNewProduct, SETTINGS);
                        tempNewProduct.otherTaxEuro = getProductOtherTax(tempNewProduct, SETTINGS);
                        tempNewProduct.witholdTaxEuro = getProductWithholdTax(tempNewProduct, SETTINGS);
                        tempNewProduct.feeEuro = getProductFee(tempNewProduct, SETTINGS);
                        tempNewProduct.stampEuro = getProductStamp(tempNewProduct, SETTINGS);
                        if (productData.vatIncludedBuy === "true") {
                            let price = isNaN(Number(productData.buyPrice)) ? 0 : productData.buyPrice;
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, price);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes, tempNewProduct.vat);
                        } else {
                            tempNewProduct.vat = getVatValue(tempNewProduct.netValue, tempNewProduct.vatPercentage);
                            tempNewProduct.totalValue = getTotalValue(tempNewProduct.netValue, tempNewProduct.vatPercentage, tempNewProduct.taxes);
                        }
                    }
                    if (productData.accountingNonDeductibleVAT) tempNewProduct.accountingNonDeductibleVAT = productData.accountingNonDeductibleVAT;
                    // If validated fields done add new row
                    let oldBuysProducts = BUYS.newBuys.products;
                    let updatePriceListNewProduct = Object.assign({}, tempNewProduct);
                    updatePriceListNewProduct.name = tempNewProduct.name;
                    updatePriceListNewProduct.code = tempNewProduct.code;
                    updatePriceListNewProduct.no = oldBuysProducts.length + 1;
                    updatePriceListNewProduct.id = oldBuysProducts.length + 1;
                    updatePriceListNewProduct._id = tempNewProduct._id
                    dispatch(setNewBuysNewProduct(tempNewProduct)); // Update redux
                    let pPlroducts = [...oldBuysProducts, updatePriceListNewProduct];
                    let productTotals = getBuysTotals(pPlroducts, SETTINGS);
                    let productBuysTaxes = getBuysTaxesData(pPlroducts, BUYS.newBuys.extraData, productTotals, SETTINGS);
                    let extraData = {...BUYS.newBuys.extraData};
                    if (productBuysTaxes.length > 0) {
                        productBuysTaxes.map((buysTax) => {
                            if (buysTax.vatPercentage === "Invoice Level Tax") {
                                extraData.witholdTaxEuro = buysTax.withholdTaxes;
                                extraData.otherTaxEuro = buysTax.otherTaxes;
                                extraData.feeEuro = buysTax.fees;
                                extraData.stampEuro = buysTax.stamp;
                            }
                            return buysTax;
                        })
                    }
                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if (productBuysTaxes.length > 0 && productBuysTaxes[0].vatPercentage === "Invoice Level Tax") {
                        totalTaxes = parseFloat((Number(productBuysTaxes[0].otherTaxes) + Number(productBuysTaxes[0].fees) + Number(productBuysTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productBuysTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productBuysTaxes[0].deductions).toFixed(2);
                    }
                    if (totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0) {
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }
                    dispatch(setNewBuysNewProduct(BUYS.newBuysNewProductInitialValue)); // Reset new category mydata
                    dispatch(setNewBuys({
                        ...BUYS.newBuys,
                        products: pPlroducts,
                        buysTaxes: productBuysTaxes, ...productTotals,
                        extraData: extraData
                    }));
                }
            }
            setProductTableSpinner('false');
        },
        update: async (data, id) => {
            // Set if editing the form
            if (!saveBuys) dispatch(setSaveBuys(true));

            // Set Loading true
            setProductTableSpinner('true');
            let quickEdit = false;
            let foundProduct;
            let productData = null;
            let plProducts = BUYS.newBuys.products.slice();
            // Quick Edit Product from the buys product table
            if (data.quickEdit) {
                let qeProduct = await getObjectFromArrayOfObjects(plProducts, id, '_id');
                if (qeProduct.length > 0) {
                    data.code = qeProduct['0'].code;
                }
                foundProduct = plProducts.find(item => item._id === id);
            } else {
                foundProduct = plProducts.find(item => item.id === id);
            }
            if (foundProduct.quickEdit === true) quickEdit = true;
            if (data.isPerDiscount && (data.isPerDiscount === "on" || data.isPerDiscount === "true")) {
                data.isPerDiscount = "true";
                data.isDiscountAmount = "false";
            }
            if (data.isDiscountAmount && (data.isDiscountAmount === "on" || data.isDiscountAmount === "true")) {
                data.isPerDiscount = "false";
                data.isDiscountAmount = "true";
            }
            if (data.name && data.name === '') {
                toast.error("Name is mandatory field.");
            } else if (data.code && data.code === '') {
                toast.error("Code is mandatory field.");
            } else {
                if (foundProduct) {
                    let papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(foundProduct.code)}`;
                    if (data.code && data.code !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-code/${encodeURIComponent(data.code)}`;
                    } else if (data.name && data.name !== '') {
                        papiUrl = process.env.REACT_APP_API_URL2 + `/category/get-product-by-name/${encodeURIComponent(data.name)}`;
                    }
                    let loadingProduct = true;
                    if (loadingProduct) {
                        // Get product data from api.
                        await axios.get(papiUrl, {params: company})
                            .then(res => {
                                if (res.data && res.data.data && (res.data.data?.length > 0) && res.data.status === '200') {
                                    productData = res.data.data['0'];
                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                    if (data.name || data.code) {
                        quickEdit = false;
                    }
                    // Field auto population on change product
                    if (((data.code && data.code !== '') || (data.name && data.name !== ''))) {
                        data.withHoldTax = productData.withholdTax;
                        data.otherTax = productData.otherTaxes;
                        data.stamp = productData.stamp;
                        data.fee = productData.fee;
                    }
                    // Updated selected product with updated field data.
                    foundProduct = {...foundProduct, ...data}
                    foundProduct._id = productData._id;

                    if (!quickEdit) {
                        if (productData?.showAlternativeNameOnPrint === "true") {
                            foundProduct.showAlternativeNameOnPrint = "true";
                            foundProduct.alternativeName = productData.alternateName;
                        } else {
                            foundProduct.showAlternativeNameOnPrint = undefined;
                            foundProduct.alternativeName = undefined;
                        }
                    }
                    if (productData?.showAlternativeCodeOnPrint === "true") {
                        foundProduct.showAlternativeCodeOnPrint = "true";
                        foundProduct.alternativeCode = productData.alternateCode;
                    } else {
                        foundProduct.showAlternativeCodeOnPrint = undefined;
                        foundProduct.alternativeCode = undefined;
                    }

                    if (productData?.specialOption) {
                        foundProduct.specialOption = productData.specialOption;
                    } else {
                        foundProduct.specialOption = undefined;
                    }

                    let discountType = 'euro';
                    if (foundProduct.isPerDiscount === 'true') {
                        discountType = 'per'
                    }
                    // Note: For inclusive vat the value is reducing by the vat percentage.
                    if (data.discount && data.discount !== '') { // on discount field change
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct?.vatType, discountType);
                    }
                    // Re Calculate Unit price if net value changed
                    if (data.netValue && data.netValue !== '' && foundProduct.isTaxLine !== "true") {
                        // If user enters value here, you calculate "Unit Price" automatically (based on previous axiom: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount")
                        foundProduct.unitPrice = getUnitPrice(data.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        if (foundProduct.isTaxLine === "true") {
                            foundProduct.netValue = 0;
                        } else {
                            foundProduct.netValue = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                    }
                    foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                    foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
                    foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
                    foundProduct.stampEuro = getProductStamp(foundProduct, SETTINGS);
                    if (!isEmpty(productData?.deductionsEuro) && parseFloat(productData?.deductionsEuro) > 0) {
                        foundProduct.deductionsEuro = Number(parseFloat(productData?.deductionsEuro).toFixed(2));
                    }
                    if (foundProduct.isTaxLine === "true") {
                        foundProduct.taxes = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                    } else {
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                    }
                    // Re Calculate Unit price and net value if total value changed
                    let userTotalValInput = 0; // For recalculating vat +-

                    if (data.totalValue && data.totalValue !== '') {
                        if (foundProduct.isTaxLine === "true") {
                            foundProduct.taxes = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.taxes, foundProduct.quantity, foundProduct.discount, discountType);
                            foundProduct.netValue = 0;
                        } else {
                            // If user enters value here, you calculate "Unit Price" and "Net Value" automatically (based on axioms: "Net Value" has to equal: "Quantity" times "Unit Price" minus "Discount" and "Total Value" equals: "VAT %" times "Net Value" plus "Net Value")
                            foundProduct.netValue = getNetValueByTotalValue(data.totalValue, foundProduct.vatPercentage, foundProduct.taxes);
                            foundProduct.unitPrice = getUnitPrice(foundProduct.netValue, foundProduct.quantity, foundProduct.discount, discountType);
                        }
                        userTotalValInput = data.totalValue;
                        //foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    } else {
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    }
                    if (foundProduct.isTaxLine === "true") {
                        foundProduct.vat = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                    } else {
                        if (foundProduct._id !== productData._id && foundProduct.isTaxLine !== "true") {
                            foundProduct.code = productData.code;
                            foundProduct.name = productData.name;
                            foundProduct.unitPrice = isNaN(Number(productData.buyPrice)) ? 0 : productData.buyPrice;
                            foundProduct.measurementUnit = productData.measurementUnit;
                            foundProduct.netValue = (Number(foundProduct.quantity) * Number(foundProduct.unitPrice)).toFixed(2);
                            foundProduct.vatPercentage = !isNaN(productData.vat) ? productData.vat : 0;
                            foundProduct.totalValue = productData.vatIncludedBuy === "true" ? getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat) : getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                        }
                        if (data.vat) {
                            foundProduct.vat = +parseFloat(data.vat).toFixed(2) || 0;
                        } else {
                            foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                        }
                    }
                    const myDataData = productData.mydata.filter(myData => String(myData.invoiceType) === BUYS.newBuys.myDataType?.toString() && myData.rowType === "expense");
                    if (productData?.isTaxLine === "true") {
                        if (!quickEdit) foundProduct.vatPercentage = getVatPercent(supplierVatCategory, productData.vat, supplierCustomVat);
                        if (!quickEdit) foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        if (!quickEdit) foundProduct.vatReason = supplierVatReason !== "" ? supplierVatReason : productData?.vatReason;
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct?.vatType, discountType);
                        foundProduct.netValue = 0;
                        foundProduct.withHoldTax = productData.withholdTax;
                        foundProduct.otherTax = productData.otherTaxes;
                        foundProduct.stamp = productData.stamp;
                        foundProduct.fee = productData.fee;
                        foundProduct.stamp = productData.stamp;
                        foundProduct._id = productData._id;
                        foundProduct.isTaxLine = productData.isTaxLine;
                        if (myDataData.length > 0) {
                            if (!quickEdit) foundProduct.classificationCategory = myDataData[0].category;
                            if (!quickEdit) foundProduct.classificationType = myDataData[0].type;
                        } else {
                            foundProduct.classificationCategory = '';
                            foundProduct.classificationType = '';
                        }

                        foundProduct.isTaxLineWithoutVat = productData.isTaxLineWithoutVat;
                        foundProduct.taxes = getNetValue(foundProduct.unitPrice, foundProduct.quantity, foundProduct.discount, discountType);
                        foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro = getProductStamp(foundProduct, SETTINGS);
                        foundProduct.vat = getVatValue(foundProduct.taxes, foundProduct.vatPercentage);
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes);
                    } else {
                        if (!quickEdit) foundProduct.vatPercentage = getVatPercent(supplierVatCategory, productData.vat, supplierCustomVat);
                        if (!quickEdit) foundProduct.vatId = getDefaultOptionByValue(vatCategoryData, productData?.vat, 'percentage', 'code', 'percentage').label;
                        if (!quickEdit) foundProduct.vatReason = supplierVatReason !== "" ? supplierVatReason : productData?.vatReason;
                        foundProduct.discount = getDiscountExclusiveVat(foundProduct.discount, foundProduct?.vatPercentage, foundProduct?.vatType, discountType);
                        foundProduct.withHoldTax = productData.withholdTax;
                        foundProduct.otherTax = productData.otherTaxes;
                        foundProduct.stamp = productData.stamp;
                        foundProduct.fee = productData.fee;
                        foundProduct.stamp = productData.stamp;
                        foundProduct._id = productData._id;
                        if (myDataData.length > 0) {
                            if (!quickEdit) foundProduct.classificationCategory = myDataData[0].category;
                            if (!quickEdit) foundProduct.classificationType = myDataData[0].type;
                        } else {
                            foundProduct.classificationCategory = '';
                            foundProduct.classificationType = '';
                        }
                        foundProduct.taxes = getTaxes(foundProduct, SETTINGS);
                        foundProduct.otherTaxEuro = getProductOtherTax(foundProduct, SETTINGS);
                        foundProduct.witholdTaxEuro = getProductWithholdTax(foundProduct, SETTINGS);
                        foundProduct.feeEuro = getProductFee(foundProduct, SETTINGS);
                        foundProduct.stampEuro = getProductStamp(foundProduct, SETTINGS);
                        if (isEmpty(data.vat)) foundProduct.vat = getVatValue(foundProduct.netValue, foundProduct.vatPercentage, userTotalValInput);
                        foundProduct.totalValue = getTotalValue(foundProduct.netValue, foundProduct.vatPercentage, foundProduct.taxes, foundProduct.vat);
                    }
                    if (productData.accountingNonDeductibleVAT) foundProduct.accountingNonDeductibleVAT = productData.accountingNonDeductibleVAT;

                    const updatedPmProducts = {...plProducts[foundProduct.no - 1], ...foundProduct}
                    let productBuysTaxes;

                    plProducts[foundProduct.no - 1] = updatedPmProducts;
                    let productTotals = getBuysTotals(plProducts, SETTINGS);
                    productBuysTaxes = getBuysTaxesData(plProducts, BUYS.newBuys.extraData, productTotals, SETTINGS);
                    let totalTaxes = 0;
                    let withHoldTaxes = 0;
                    let deductions = 0;
                    if (productBuysTaxes.length > 0 && productBuysTaxes[0].vatPercentage === "Invoice Level Tax") {
                        totalTaxes = parseFloat((Number(productBuysTaxes[0].otherTaxes) + Number(productBuysTaxes[0].fees) + Number(productBuysTaxes[0].stamp)).toString());
                        withHoldTaxes = parseFloat(productBuysTaxes[0].withholdTaxes).toFixed(2);
                        deductions = parseFloat(productBuysTaxes[0].deductions).toFixed(2);
                    }
                    if (totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0) {
                        productTotals.paymentAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes) - parseFloat(deductions)).toFixed(2);
                        productTotals.totalAmount = parseFloat(parseFloat(productTotals.totalAmount) + parseFloat(totalTaxes)).toFixed(2);
                    }
                    dispatch(setNewBuys({
                        ...BUYS.newBuys,
                        products: plProducts,
                        buysTaxes: productBuysTaxes, ...productTotals
                    })); // update data

                    if (productBuysTaxes.length > 0) {
                        productBuysTaxes.map((buysTax) => {
                            if (buysTax.vatPercentage === "Invoice Level Tax") {
                                let extraData = {};
                                extraData.witholdTaxEuro = buysTax.withholdTaxes;
                                extraData.otherTaxEuro = buysTax.otherTaxes;
                                extraData.feeEuro = buysTax.fees;
                                extraData.stampEuro = buysTax.stamp;
                                dispatch(setNewBuysExtraData({...BUYS.newBuys.extraData, ...extraData}));
                            }
                            return buysTax;
                        })
                    }
                    setProductTableSpinner('false');

                }
            }
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveBuys) dispatch(setSaveBuys(true));

            let cloneProducts = structuredClone(BUYS.newBuys.products);
            cloneProducts.splice(rowIndex, 1);
            cloneProducts.forEach((prod, idx) => {
                prod.no = idx + 1;
                prod.id = String(idx + 1);
            })
            dispatch(setNewBuys({...BUYS.newBuys, products: cloneProducts}));
            setUpdateBuyAmounts(true);
        }
    }
    const selectedDocumentType = getDefaultOptionByValue(documentTypesOptions, BUYS.newBuys.documentType, 'value', 'label', 'value');
    let tableWrClasses = "product-form sales-products-list position-relative";
    if (BUYS.newBuys.supplier !== '') {
        tableWrClasses += " normalIndex";
    }
    let cashRegistersData = cashRegisters.filter((register) => register.isActive === "active");
    let cashRegisterOptions = [{
        value: "",
        label: t("General.empty")
    }, ...getOptionsByData(cashRegistersData, "_id", "name")];

    const newBuysTab = [
        {
            tabName: t("General.products"),
            tabData: (
                <div className={tableWrClasses}>
                    {((BUYS.newBuys.supplier === '' && BUYS.newBuys.newSupplier === '') && BUYS.newBuys.employee === '') &&
                        <div className="overlay_w">{t("Required.selectSupplierFirst")}</div>}
                    {showProductTableSpinner && showProductTableSpinner === 'true' && <div className="overlay_w">
                        <div className="spinner-border" role="status"><span
                            className="sr-only">{t("General.loading")}</span></div>
                    </div>}
                    {BUYS.newBuys?.products && BUYS.newBuys?.products?.length === 0 &&
                        <span className="text-danger">{t("Required.productList")}</span>}
                    <EditableTable
                        tableName="Buys Products List"
                        key={"Buys Products List" + incrKey}
                        actionButtons={{
                            print: false,
                            delete: true,
                            export: false,
                            edit: true,
                        }}
                        columns={supplierProductsColumns}
                        pRequestData={pRequestData}
                        data={BUYS.newBuys.products}
                        allowInsertRow={true}
                        onUpdate={buysProductListActions}
                        allowActions={true}
                        allowToggleColumns={false}
                        allowPrintResults={false}
                    />
                </div>
            ),
        },
        {
            tabName: t("General.extraData"),
            tabData: (
                <>
                    <Row>
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t("General.otherTaxes")}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(otherTaxesOptions, BUYS.newBuys.extraData.otherTax, 'value', 'label', 'value')}
                                name="otherTax"
                                options={otherTaxesOptions}
                                onChange={(e) => handleOnChangeExtraData(e, 'dd', 'otherTax')}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t("General.withholdTaxes")}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(withHoldTaxesOptions, BUYS.newBuys.extraData.withHoldTax, 'value', 'label', 'value')}
                                name="withHoldTax"
                                options={withHoldTaxesOptions}
                                onChange={(e) => handleOnChangeExtraData(e, 'dd', 'withHoldTax')}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t("General.fees")}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(feesOptions, BUYS.newBuys.extraData.fee, 'value', 'label', 'value')}
                                name="fee"
                                options={feesOptions}
                                onChange={(e) => handleOnChangeExtraData(e, 'dd', 'fee')}
                            />
                        </Col>
                        <Col sm={12} md={3} className="mb-2">
                            <Dropdown
                                label={t("General.stampDuty")}
                                key={Math.random()}
                                defaultValue={getDefaultOptionByValue(stampOptions, BUYS.newBuys.extraData.stamp, 'value', 'label', 'value')}
                                name="stamp"
                                options={stampOptions}
                                onChange={(e) => handleOnChangeExtraData(e, 'dd', 'stamp')}
                            />
                        </Col>
                        <Col md={3}>
                            <label>{"Ποσό κρατήσεων"}</label>
                            <AccountingBox
                                name={"deductionsEuro"}
                                defaultValue={BUYS.newBuys.extraData.deductionsEuro}
                                onBlur={(e) => handleOnChangeExtraData(e, "acb", "deductionsEuro")}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={3}>
                            <Dropdown
                                name={"specialInvoiceCategory"}
                                label={"Ειδική Κατηγορία Παραστατικού"}
                                key={Math.random()}
                                defaultValue={specialInvoiceCategoryOptions.find((el) => el.value === BUYS.newBuys.specialInvoiceCategory) ? specialInvoiceCategoryOptions.find((el) => el.value === BUYS.newBuys.specialInvoiceCategory) : ""}
                                options={specialInvoiceCategoryOptions}
                                onChange={(e) => handleOnChange(e, "dd", "specialInvoiceCategory")}
                            />
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                name={"cashRegister"}
                                label={t("General.cashRegister")}
                                key={Math.random()}
                                defaultValue={cashRegisterOptions.find((el) => el.value === BUYS.newBuys.extraData?.cashRegister) ? cashRegisterOptions.find((el) => el.value === BUYS.newBuys.extraData?.cashRegister) : ""}
                                options={cashRegisterOptions}
                                onChange={(e) => handleOnChangeExtraData(e, "dd", "cashRegister")}
                            />
                        </Col>
                        {["14.1", "14.31"].includes(BUYS.newBuys?.myDataType) && (
                            <Col md={3} className="mt-4">
                                <BetterCheckBox
                                    name="isTriangularTrade"
                                    text="Αφορά τριγωνική συναλλαγή ('Εντυπο Φ5)"
                                    checked={
                                        BUYS.newBuys.extraData?.isTriangularTrade === "true"
                                    }
                                    onChange={(e) => handleOnChangeExtraData(e, "cb", "isTriangularTrade")}
                                />
                            </Col>
                        )}
                    </Row>
                </>
            ),
        },
    ];

    const handleOtherCorrelatedInvoicesTableUpdate = {
        insert: (e) => {
            if (e.row) {
                if (!saveBuys) dispatch(setSaveBuys(true));
                if (BUYS.newBuys?.otherCorrelatedInvoices?.some((el) => el.docMark === e.row.docMark)) {
                    dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedInvoices: BUYS.newBuys.otherCorrelatedInvoices}));
                    return toast.error("Έχετε ήδη επιλέξει αυτό το παραστατικό.");
                }
                let clone = [];
                if (BUYS.newBuys?.otherCorrelatedInvoices?.length > 0) {
                    clone = structuredClone(BUYS.newBuys?.otherCorrelatedInvoices);
                }
                let cloneRow = {...e.row};
                delete cloneRow.date;
                clone.push(cloneRow);
                dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedInvoices: clone}));
            }
        },
        update: (data, id, rowIndex, e) => {
            if (!saveBuys) dispatch(setSaveBuys(true));
            const findSame = BUYS.newBuys?.otherCorrelatedInvoices?.findIndex((el) => el.docMark === e.row.docMark);
            if (e.row?.docMark && findSame !== rowIndex) {
                dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedInvoices: BUYS.newBuys.otherCorrelatedInvoices}));
                setTimeout(() => setIncrKey3(incrKey3 + 1), 50);
                return toast.error("Έχετε ήδη επιλέξει αυτό το παραστατικό.");
            }
            let clone = structuredClone(BUYS.newBuys?.otherCorrelatedInvoices);
            let cloneRow = {...e.row}
            delete cloneRow.date;
            clone[rowIndex] = {...clone[rowIndex], ...cloneRow}
            dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedInvoices: clone}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (rowIndex >= 0) {
                if (!saveBuys) dispatch(setSaveBuys(true));
                let clone = structuredClone(BUYS.newBuys?.otherCorrelatedInvoices);
                clone.splice(rowIndex, 1);
                dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedInvoices: clone}));
            }
        },
    }

    const otherCorrelatedInvoicesTableColumns = [
        {
            name: "Παραστατικό",
            field: "docInfo",
            width: "60%",
            editable: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: [
                        {label: "Ημ/νια", name: "date"},
                        {label: "Παραστατικό", name: "docInfo"},
                        {label: "ΜΑΡΚ", name: "docMark"},
                        {label: "Τύπος", name: "docMyDataType"},
                    ],
                    data: otherCorrelatedInvoicesDefaultData,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Εισάγετε παραστατικό",
                    onChangeSearchCell: (cellName, keyword, setData) => fetchOtherCorrelatedInvoicesData(keyword, setData),
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "MARK",
            field: "docMark",
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
        {
            name: "Επιπλέον πληροφορίες",
            field: "docNotes",
            width: "20%",
            inputType: {
                type: 'text',
            }
        },
    ]

    const otherCorrelatedInvoicesTab = {
        tabName: "Συσχέτιση Παραστατικών",
        tabData: (
            <React.Fragment>
                <div className="text-muted mb-2"><i>Συσχέτιση διαβιβασμένων Παραστατικών</i></div>
                <EditableTable
                    name={"New Buy Other Correlated Invoices"}
                    columns={otherCorrelatedInvoicesTableColumns}
                    key={incrKey3}
                    data={BUYS.newBuys?.otherCorrelatedInvoices ? BUYS.newBuys?.otherCorrelatedInvoices : []}
                    allowActions={true}
                    allowInsertRow={true}
                    onUpdate={handleOtherCorrelatedInvoicesTableUpdate}
                />
            </React.Fragment>
        )
    }

    const quickEditSupplier = (e, type, data) => {
        let selectedSupplier = BUYS.newBuys.supplier;
        if (selectedSupplier) {
            let quickSupplierData = {};
            // Quick Edit Supplier Details Data
            quickSupplierData._id = BUYS.newBuys.supplier;
            quickSupplierData.company = company.id;
            quickSupplierData.name = data.name;
            quickSupplierData.vatCategory = data.vatCategory;
            quickSupplierData.vatNumber = data.vatNumber;
            quickSupplierData.address = data.address;
            quickSupplierData.city = data.city;
            quickSupplierData.amka = data?.amka;
            quickSupplierData.categoryName = data?.supplierCategoryName;
            quickSupplierData.category = data?.supplierCategory;
            quickSupplierData.email = data.email;
            quickSupplierData.phone = data.phone;

            if ((data.email !== '' || data.phone !== '') && data.name !== '' && data.vatCategory !== '') {
                dispatch(putSupplier(quickSupplierData, requestData));
                // Repopulate the suppler data to buys after updating the supplier.
                let sSupplier = data;
                let repopulateSupplier = {};
                repopulateSupplier.supplierCategoryName = sSupplier?.supplierCategoryName;
                repopulateSupplier.supplierCategory = sSupplier?.supplierCategory;
                repopulateSupplier.supplierName = sSupplier.name;
                repopulateSupplier.address = sSupplier.address;
                repopulateSupplier.vat = sSupplier.vatNumber;
                repopulateSupplier.vatCategory = sSupplier.vatCategory;
                repopulateSupplier.city = sSupplier.city;
                repopulateSupplier.amka = sSupplier?.amka;
                repopulateSupplier.email = sSupplier.email;
                repopulateSupplier.pc = sSupplier.postalCode;
                repopulateSupplier.phone = sSupplier.phone;

                let buysData = Object.assign({}, BUYS);
                dispatch(setNewBuys({...buysData.newBuys, ...repopulateSupplier}));

            } else {
                toast.error('Name, Email or Phone and Vat Category required fields.');
            }
        }
    }

    const clearSupplier = () => {
        if (BUYS.newBuys.supplier !== '') {
            let newBuysData = {};
            let buysData = Object.assign({}, BUYS);
            newBuysData.supplier = "";
            newBuysData.supplierName = "";
            newBuysData.supplierCode = "";
            newBuysData.address = "";
            newBuysData.vat = "";
            newBuysData.doy = "";
            newBuysData.city = "";
            newBuysData.supplierCategoryName = "";
            newBuysData.supplierCategory = "";
            newBuysData.country = "";
            newBuysData.pc = "";
            newBuysData.email = "";
            newBuysData.phone = "";
            newBuysData.activity = "";
            newBuysData.vatCategory = "";
            setSupplierInstallationListData([]);
            newBuysData.supplierInstallationType = "";
            newBuysData.supplierInstallationId = "";
            // Set Supplier Vat Category used for product vat calculation
            dispatch(setNewBuySupplierCustomData({
                supplierVatCategory: "Normal VAT",
                supplierVatReason: "",
                supplierCustomVat: 0,
            }))
            dispatch(setNewBuys({...buysData.newBuys, ...newBuysData}));
        }
    }

    const hookNewSupplierInBuy = (newSupplierData) => {
        if (newSupplierData) {
            const supplierBasicData = {
                supplierName: newSupplierData.name,
                supplier: newSupplierData._id,
                supplierCode: newSupplierData.systemCode,
                supplierType: 'Existing',
                address: newSupplierData.address,
                vat: newSupplierData.vatNumber,
                doy: getDOYOptions().find((el) => String(el.value) === String(newSupplierData.DOY))?.label,
                city: newSupplierData.city,
                supplierCategoryName: newSupplierData.categoryName,
                supplierCategory: newSupplierData.category,
                pc: newSupplierData.postalCode,
                country: newSupplierData.country,
                supplierInstallationId: "0",
                supplierInstallationType: "1",
                email: newSupplierData.email,
                phone: newSupplierData.phone,
                activity: newSupplierData.activity
            }
            newSupplierData.installations.map(installation => {
                installation.type = getLabelByValue(getInstallationsTypes(), installation.type, 'value');
                return installation;
            })
            supplierBasicData.supplierInstallationType = newSupplierData.installations[0]?.type;
            supplierBasicData.supplierInstallationId = newSupplierData.installations[0]?.no;

            const buysData = BUYS.newBuys;
            const newBuysData = {...buysData, ...supplierBasicData}

            dispatch(setNewBuys(newBuysData));
        }
    }
    // Data For Quick Edit Supplier Details on selection
    let quickEditSupplierData = {};
    if (BUYS.newBuys.supplierType === 'Existing') {
        if (BUYS.newBuys.supplier && BUYS.newBuys.supplier !== "") {
            quickEditSupplierData.name = BUYS.newBuys.supplierName;
            quickEditSupplierData.id = BUYS.newBuys.supplier;
            quickEditSupplierData.vatCategory = BUYS.newBuys.vatCategory;
            quickEditSupplierData.address = BUYS.newBuys.address;
            quickEditSupplierData.vatNumber = BUYS.newBuys.vat;
            quickEditSupplierData.doy = getLabelByValue(getDOYOptions(), Number(BUYS.newBuys.doy), 'value');
            quickEditSupplierData.city = BUYS.newBuys.city;
            quickEditSupplierData.supplierCategory = BUYS.newBuys.supplierCategory;
            quickEditSupplierData.supplierCategoryName = BUYS.newBuys.supplierCategoryName;
            quickEditSupplierData.pc = BUYS.newBuys.pc;
            quickEditSupplierData.email = BUYS.newBuys.email;
            quickEditSupplierData.phone = BUYS.newBuys.phone;
        }
    }

    let buysTaxesColumns = [
        {
            name: t("General.vatPercentage"),
            field: "vatPercentage",
            editable: false,
        },
        {
            name: t("General.netValue"),
            field: "netValue",
            editable: false,
        },
        {
            name: t("General.vatValue"),
            field: "vatEuro",
            editable: false,
        },
        {
            name: t("General.withholdTaxes"),
            field: "withholdTaxes",
            editable: false,
        },
        {
            name: t("General.otherTaxes"),
            field: "otherTaxes",
            editable: false,
        },
        {
            name: t("General.fees"),
            field: "fees",
            editable: false,
        },
        {
            name: t("General.stampDuty"),
            field: "stamp",
            editable: false,
        },
        {
            name: "Κρατήσεις",
            field: "deductions",
            editable: false,
        }
    ];
    let totalTaxes = 0;
    let withHoldTaxes = 0;
    let deductions = 0;
    let productTotals = useMemo(() => getBuysTotals(BUYS.newBuys.products, SETTINGS), [BUYS.newBuys.products]);
    let buysTaxesData = useMemo(() => getBuysTaxesData(BUYS.newBuys.products, BUYS.newBuys.extraData, productTotals, SETTINGS), [BUYS.newBuys.products, BUYS.newBuys.extraData]);
    if (buysTaxesData.length > 0 && buysTaxesData[0].vatPercentage === "Invoice Level Tax") {
        totalTaxes = parseFloat((Number(buysTaxesData[0].otherTaxes) + Number(buysTaxesData[0].fees) + Number(buysTaxesData[0].stamp)).toString());
        withHoldTaxes = parseFloat(buysTaxesData[0].withholdTaxes).toFixed(2);
        deductions = parseFloat(buysTaxesData[0].deductions).toFixed(2);
    }
    let totalQuantity = productTotals.totalQuantity;
    let totalBeforeDiscount = productTotals.totalBeforeDiscount;
    let totalDiscount = productTotals.totalDiscount;
    let totalNetValue = productTotals.totalNetValue;
    let totalAmount = productTotals.totalAmount;
    //let paymentAmount = productTotals.paymentAmount;
    let totalVatAmount = productTotals.totalVatValue;
    if (totalTaxes !== 0 || withHoldTaxes !== 0 || deductions !== 0) {
        totalAmount = parseFloat(totalAmount) + parseFloat(totalTaxes);
        //paymentAmount = parseFloat(paymentAmount) + parseFloat(totalTaxes) - parseFloat(withHoldTaxes);
    }
    totalTaxes += Number(productTotals.totalTaxesAmount);
    withHoldTaxes = parseFloat(parseFloat(productTotals.withHoldTaxes) + parseFloat(withHoldTaxes));
    const selectPaymentTypeOptions = getDefaultOptionByValue(paymentTypeOptions, BUYS.newBuys.paymentType, 'value', 'label', 'value');

    useEffect(() => {
        if (updateBuyAmounts === true) {
            setUpdateBuyAmounts(false);
            let extraData = {};
            if (buysTaxesData.length > 0) {
                buysTaxesData.forEach((buysTax) => {
                    if (buysTax.vatPercentage === "Invoice Level Tax") {
                        buysTax.witholdTaxEuro = buysTax.withholdTaxes;
                        buysTax.otherTaxEuro = buysTax.otherTaxes;
                        buysTax.feeEuro = buysTax.fees;
                        buysTax.stampEuro = buysTax.stamp;
                    }
                })
            }
            dispatch(setNewBuys({
                ...BUYS.newBuys,
                buysTaxes: buysTaxesData,
                extraData: {...BUYS.newBuys.extraData, ...extraData},
                ...productTotals,
            }))
        }
    }, [updateBuyAmounts])

    return (
        <div className="new-buys">
            <div className="supplier-form product-form position-relative">
                {disabledFields && <div className="overlay_w">{t("Required.selectDocumentFirst")}</div>}
                <Row className="border-bottom mb-2">
                    <Col sm={12} md={3} className="showWithOverlay">
                        <Dropdown
                            label={t('General.documentType')}
                            key={Math.random()}
                            defaultValue={selectedDocumentType}
                            required={true}
                            searchEnable={true}
                            name="documentType"
                            options={documentTypesOptions}
                            onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                        />
                    </Col>
                    <Col md={3} className={"mt-4"}>
                        {!isEmpty(BUYS.newBuys.myDataType) && (
                            <h6 style={{color: "red"}}>Προσοχή! Το παραστατικό θα σταλεί στο My Data!</h6>
                        )}
                    </Col>
                    <Col sm={12} md={6}>
                        <div className="d-flex justify-content-end">
                            <div className="mydata-status disabled-page">
                                <Dropdown
                                    label={t("General.myDataStatus")}
                                    options={buysMyDataStatusOptions}
                                    defaultValue={getDefaultOptionByValue(buysMyDataStatusOptions, BUYS.newBuys.myDataStatus, 'value', 'label', 'value')}
                                    name="myDataStatus"
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col sm="12" md="3">
                        {/* If "MyData rules" is enabled in "Settings-Document Types-Advanced Types", then FIELD IS READ ONLY. Select current date only. */}
                        <DateBox
                            classes="w-100"
                            label={t('General.date')}
                            name="date"
                            selected={moment(BUYS.newBuys.date).isValid() ? new Date(BUYS.newBuys.date) : null}
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                        {saveBuys && isEmpty(BUYS.newBuys.date) &&
                            <div className={"text-danger"}>Απαιτείται Ημερομηνία.</div>}
                    </Col>
                    <Col sm="12" md="3">
                        <HourPicker
                            label={t("General.time")}
                            selected={moment(BUYS.newBuys.time, "HH:mm").toDate()}
                            onChange={(e) => handleOnChange(e, "tp", "time")}
                        />
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    <Col sm="12" md="4">
                        <Dropdown
                            className={"mb-0"}
                            label={t("General.installation")}
                            options={installationOptions}
                            value={getDefaultOptionByValue(installationOptions, BUYS.newBuys.installation, 'value', 'label', 'value')}
                            enabledValue={true}
                            searchEnable={true}
                            required={true}
                            name="installation"
                            onChange={(e) => handleOnChange(e, 'dd', 'installation')}
                        />
                        {saveBuys && isEmpty(BUYS.newBuys.installation) &&
                            <div className="text-danger">{t("Required.installation")}</div>}
                    </Col>
                    <Col sm="12" md="4">
                        <Input
                            className="w-100"
                            label={t("General.preNumber")}
                            name="preNumber"
                            type="text"
                            required={true}
                            value={BUYS.newBuys.preNumber}
                            placeholder="Εισάγετε Σειρά"
                            onChange={(e) => handleOnChange(e)}
                            disabled={false}
                        />
                        {saveBuys && isEmpty(BUYS.newBuys.preNumber) &&
                            <div className="text-danger">{t("Required.preNumber")}</div>}
                    </Col>
                    <Col sm="12" md="4">
                        <Input
                            className="w-100"
                            label={t("General.number")}
                            name="number"
                            required={true}
                            value={BUYS.newBuys.number}
                            placeholder="Εισάγετε Αριθμό"
                            onChange={(e) => handleOnChange(e)}
                        />
                        {saveBuys && isEmpty(BUYS.newBuys.number) &&
                            <div className="text-danger">{t("Required.number")}</div>}
                    </Col>
                </Row>
                <Row className={"mb-2"}>
                    {BUYS.newBuys.supplierType === 'Employee' &&
                        <Col sm="30" md="5">
                            <AdvancedCombobox
                                ACName="Buys Employee" // do not change name
                                className="w-200 ac-select-dropdown"
                                defaultValue={BUYS.newBuys.employeeName}
                                key={Math.random()}
                                label="Employee"
                                data={employeeListData}
                                onChangeSearch={onChangeSearch}
                                onChange={(e) => handleOnChange(e, 'acdd', 'employee')}
                                excludeColumns={[]}
                                columns={employeeDropdownColumns}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder='Select Employee'
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                            />
                            {saveBuys && BUYS.newBuys.supplierType === 'Employee' && BUYS.newBuys.employee === "" &&
                                <div className="text-danger">Employee is required.</div>}
                        </Col>
                    }
                    {BUYS.newBuys.supplierType === 'Existing' &&
                        <Col sm="30" md="5">
                            <AdvancedCombobox
                                ACName="Buys Supplier" // do not change name
                                className="w-200 ac-select-dropdown"
                                defaultValue={BUYS.newBuys.supplierName}
                                key={Math.random()}
                                label={t("General.supplier")}
                                data={suppliersListData}
                                onChangeSearch={onChangeSearch}
                                onChange={(e) => handleOnChange(e, 'acdd', 'supplier')}
                                excludeColumns={[]}
                                columns={supplierDropdownColumns}
                                deleteEnable={false}
                                searchTableEnable={false}
                                showTableOptionOnSelect={true}
                                placeholder={t("Placeholders.selectSupplier")}
                                required={true}
                                showInsertAddButton={true}
                                hideSaveButton={true}
                                hideInsertNewRow={true}
                                inputFieldClasses="form-control"
                            />
                            {saveBuys && BUYS.newBuys.supplierType === 'New' && isEmpty(BUYS.newBuys.newSupplier) &&
                                <div className="text-danger">{t("Required.supplier")}</div>}
                            {saveBuys && BUYS.newBuys.supplierType === 'Existing' && isEmpty(BUYS.newBuys.supplier) &&
                                <div className="text-danger">{t("Required.supplier")}</div>}
                        </Col>
                    }
                    {BUYS.newBuys.supplierType === 'New' &&
                        <Col sm="30" md="5">
                            <Input
                                className="w-100 newsupplier-field"
                                label={"New Retail Supplier"}
                                name="newSupplier"
                                value={BUYS.newBuys.newSupplier}
                                placeholder="Add new retail supplier name"
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    }
                    {BUYS.newBuys.supplierType !== 'Employee' &&
                        <Col sm="1" md="1">
                            <div className="d-flex  mt-4">
                                <div className="quick-supplier-actions">
                                    {BUYS.newBuys.supplier !== '' && BUYS.newBuys.supplierType === 'Existing' &&
                                        <QuickEdit title="Edit selected supplier." key={Math.random()}
                                                   columns={quickSupplierFields} data={quickEditSupplierData}
                                                   hideCurrentValue={true} updateData={quickEditSupplier}/>}
                                    {BUYS.newBuys.supplier !== '' && BUYS.newBuys.supplierType === 'Existing' &&
                                        <button className="btn quick-retail-supplierbtn btn-default btn-sm"
                                                title="Clear Supplier Fields" key={Math.random()}
                                                onClick={clearSupplier}><i className="fas fa-xmark"></i></button>}
                                    {((BUYS.newBuys.supplier === '' && BUYS.newBuys.newSupplier === '') || BUYS.newBuys.supplierType !== 'Existing') &&
                                        <NewSupplierModal myDataType={BUYS.newBuys.myDataType}
                                                          successCallback={(data) => hookNewSupplierInBuy(data)}/>}
                                </div>
                            </div>
                        </Col>
                    }
                    {BUYS.newBuys.supplierType === 'Existing' && (
                        <Col sm="12" md="2">
                            <div className="d-flex">
                                <AdvancedCombobox
                                    ACName="Supplier Installation" // do not change name
                                    className="w-100 ac-select-dropdown"
                                    defaultValue={BUYS.newBuys.supplierInstallationType}
                                    key={Math.random()}
                                    label={t("General.supplierInstallation")}
                                    data={supplierInstallationListData}
                                    onChangeSearch={onChangeSearch}
                                    onChange={(e) => handleOnChange(e, 'acdd', 'supplierInstallation')}
                                    excludeColumns={[]}
                                    columns={supplierInstallationsDropdownColumns}
                                    deleteEnable={false}
                                    searchTableEnable={false}
                                    showTableOptionOnSelect={true}
                                    placeholder={t("General.supplierInstallation")}
                                    required={true}
                                    showInsertAddButton={true}
                                    hideSaveButton={true}
                                    hideInsertNewRow={true}
                                    inputFieldClasses="form-control"
                                />
                            </div>
                        </Col>
                    )}
                    {(BUYS.newBuys.supplierType === 'Existing' || BUYS.newBuys.supplierType === 'Employee') && (
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t("General.vatNumber")}
                                name="vat"
                                value={BUYS.newBuys.vat}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {/* Show if new supplier */}
                    {BUYS.newBuys.supplierType === 'New' &&
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t("General.email")}
                                name="email"
                                required={BUYS.newBuys.supplierType === 'New' && BUYS.newBuys.phone === ''}
                                value={BUYS.newBuys.email}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveBuys && BUYS.newBuys.supplierType === 'New' && BUYS.newBuys.email === "" && BUYS.newBuys.phone === "" &&
                                <div className="text-danger">{t("Required.emailOrPhone")}</div>}
                        </Col>
                    }
                    {/* Show if new supplier */}
                    {(BUYS.newBuys.supplierType === 'New' || BUYS.newBuys.supplierType === 'Employee') &&
                        <Col sm="12" md="2">
                            <div className="mb-2 ">
                                <Input
                                    className="w-100"
                                    label={t("General.phone")}
                                    name="phone"
                                    disabled={BUYS.newBuys.supplierType === 'Employee'}
                                    required={BUYS.newBuys.supplierType === 'New' && BUYS.newBuys.email === ''}
                                    value={BUYS.newBuys.phone}
                                    onChange={(e) => handleOnChange(e)}
                                />
                            </div>
                        </Col>
                    }
                    {BUYS.newBuys.supplierType !== 'Employee' &&
                        <Col sm="12" md="2">
                            <div className="mb-2 ">
                                <Input
                                    className="w-100"
                                    label={t("General.address")}
                                    name="address"
                                    disabled={BUYS.newBuys.supplierType === 'Employee'}
                                    value={BUYS.newBuys.address}
                                    onChange={(e) => handleOnChange(e)}
                                />
                            </div>
                        </Col>
                    }
                </Row>
                <Row className={"mb-2"}>
                    {BUYS.newBuys.supplierType === 'Existing' && (
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t("General.doy")}
                                name="doy"
                                value={BUYS.newBuys.doy}
                                onChange={(e) => handleOnChange(e)}
                                disabled={true}
                                readonly
                            />
                        </Col>
                    )}
                    {BUYS.newBuys.supplierType !== 'Employee' &&
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t("General.city")}
                                name="city"
                                value={BUYS.newBuys.city}
                                onChange={(e) => handleOnChange(e)}
                                disabled={BUYS.newBuys.supplierType !== 'New'}
                                readonly
                            />
                        </Col>
                    }
                    {BUYS.newBuys.supplierType !== 'Employee' &&
                        <Col sm="12" md="2">
                            <Input
                                className="w-100"
                                label={t("General.postalCode")}
                                name="pc"
                                value={BUYS.newBuys.pc}
                                onChange={(e) => handleOnChange(e)}
                                disabled={BUYS.newBuys.supplierType !== 'New'}
                                readonly
                            />
                        </Col>
                    }
                    {BUYS.newBuys.supplierType === 'Employee' &&
                        <Col sm="12" md="3">
                            <Dropdown
                                label={t('EmployeeNew.employeeCategory.name')}
                                name="employeeCategory"
                                width="30%"
                                placeholder={t('EmployeeNew.employeeCategory.placeholder')}
                                options={getEmployeeCategoryOptions()}
                                enabledValue={true}
                                required={true}
                                disabled={true}
                                value={getDefaultOptionByValue(getEmployeeCategoryOptions(), BUYS.newBuys.employeeCategory, 'value', 'label', 'value')}
                            />
                        </Col>
                    }
                    {BUYS.newBuys.supplierType === 'Employee' &&
                        <Col sm="12" md="3">
                            <Dropdown
                                label={t('EmployeeNew.employeeType.name')}
                                name="employeeType"
                                width="30%"
                                placeholder={t('EmployeeNew.employeeType.placeholder')}
                                options={getEmployeeTypeOptions()}
                                enabledValue={true}
                                required={true}
                                disabled={true}
                                onChange={(e) => handleOnChange(e, "dd", "employeeType")}
                                value={getDefaultOptionByValue(getEmployeeTypeOptions(), BUYS.newBuys.employeeType, 'value', 'label', 'value')}
                            />
                        </Col>
                    }
                </Row>
                <Row>
                    <Col md={4}>
                        <Dropdown
                            label={t("General.paymentType")}
                            options={paymentTypeOptions}
                            value={Object.keys(selectPaymentTypeOptions).length !== 0 ? selectPaymentTypeOptions : ''}
                            enabledValue={true}
                            required={requiredPaymentType}
                            name="paymentType"
                            searchEnable={true}
                            disabled={lockPaymentType}
                            onChange={(e) => handleOnChange(e, 'dd', 'paymentType')}
                        />
                    </Col>
                    {showBankSelection && (
                        <Col md={4}>
                            <Dropdown
                                label={"Τραπεζικός Λογαριασμός"}
                                options={bankOptions}
                                defaultValue={bankOptions.find((el) => el.value === BUYS.newBuys.bankAccount)}
                                required={requiredBankAccount}
                                name="bankAccount"
                                className={"mb-0"}
                                disabled={lockPaymentType}
                                onChange={(e) => handleOnChange(e, 'dd', 'bankAccount')}
                            />
                        </Col>
                    )}
                    {["10.1", "10.2"].includes(BUYS.newBuys.myDataType) && (
                        <React.Fragment>
                            <Col md={4}>
                                <Dropdown
                                    label={"Αιτία Έκδοσης Δελτίου"}
                                    options={receivingNotePurposeOptions}
                                    defaultValue={BUYS.newBuys?.receivingNotePurpose ? receivingNotePurposeOptions.find((el) => el.value === BUYS.newBuys?.receivingNotePurpose) : null}
                                    name="receivingNotePurpose"
                                    key={BUYS.newBuys?.receivingNotePurpose}
                                    onChange={(e) => handleOnChange(e, 'dd', 'receivingNotePurpose')}
                                />
                            </Col>
                            {BUYS.newBuys?.receivingNotePurpose === "7" && (
                                <Col md={4}>
                                    <Input
                                        label={"Τίτλος λοιπής περίπτωσης ΔΠΠ"}
                                        name={"otherReceivingNotePurposeTitle"}
                                        value={BUYS.newBuys?.otherReceivingNotePurposeTitle}
                                        charLimit={200}
                                        onChange={(e) => handleOnChange(e, 'input', 'otherReceivingNotePurposeTitle')}
                                    />
                                </Col>
                            )}
                        </React.Fragment>
                    )}
                </Row>
                <Row>
                    <Col md="12" className="mb-2">
                        <ul className="react-tabs__tab-list tab-style tab-min component-subtabs">
                            {(() => {
                                const tabs = [...newBuysTab];
                                if (["10.1", "10.2"].includes(BUYS.newBuys?.myDataType)) tabs.push(newCorrelatedEntitiesTab);
                                if (canHaveOtherCorrelations) tabs.push(otherCorrelatedInvoicesTab);

                                return tabs.map((tab, i) => (
                                    <li key={i} className="react-tabs__tab">
                                        <button
                                            type="button"
                                            onClick={() => setActiveTab(i)}
                                            className={`customNavBtn ${activeTab === i && "btnActive"}`}
                                        >
                                            <span className="textWrapper">{tab.tabName}</span>
                                        </button>
                                    </li>
                                ))
                            })()}
                        </ul>
                        {(() => {
                            const tabs = [...newBuysTab];
                            if (["10.1", "10.2"].includes(BUYS.newBuys?.myDataType)) tabs.push(newCorrelatedEntitiesTab);
                            if (canHaveOtherCorrelations) tabs.push(otherCorrelatedInvoicesTab);

                            return <div className="innerTabPanel">{tabs[activeTab]?.tabData}</div>
                        })()}
                    </Col>
                </Row>

                <Row>
                    <Col sm="12" md="8" style={{position: "inherit"}}>
                        <EditableTable
                            className="buys-taxes-calculations"
                            allowActions={false}
                            key={Math.random()}
                            data={fixDocumentTaxesDisplay(BUYS.newBuys, "buys")}
                            pRequestData={pRequestData}
                            columns={buysTaxesColumns}
                            actionButtons={{
                                print: false,
                                delete: false,
                                export: false,
                                edit: false,
                            }}
                        />
                    </Col>
                    <Col sm="12" md="4" className="d-flex justify-content-end">
                        <span className="mr-3 fw-bold">{t("General.totals")}</span>
                        <table className="table table-bordered mb-2">
                            <tbody>
                            <tr>
                                <td className="fw-bold">{t("General.totalQuantity")}</td>
                                <td>{totalQuantity}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalBeforeDiscount")}</td>
                                <td>{getGreekCurrencyFormat(totalBeforeDiscount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalDiscount")}</td>
                                <td>{getGreekCurrencyFormat(totalDiscount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalNetValue")}</td>
                                <td>{getGreekCurrencyFormat(totalNetValue)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalVatValue")}</td>
                                <td>{getGreekCurrencyFormat(totalVatAmount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalWithheldAmount")}</td>
                                <td>{getGreekCurrencyFormat(withHoldTaxes)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalTaxesAmount")}</td>
                                <td>{getGreekCurrencyFormat(totalTaxes)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.totalAmount")}</td>
                                <td>{getGreekCurrencyFormat(totalAmount)}</td>
                            </tr>
                            <tr>
                                <td className="fw-bold">{t("General.paymentAmount")}</td>
                                <td>{getGreekCurrencyFormat(BUYS.newBuys.paymentAmount)}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <div className="text-muted mb-2"><i>{t("General.notes")}</i></div>
                        <TextArea
                            rows="4"
                            placeholder={t("Placeholders.notes")}
                            name="notes"
                            value={BUYS.newBuys.notes}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </Col>
                </Row>
            </div>
            <Modal backdrop={"static"} className="themeModal" show={showCateogryConfirmation}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("General.warning")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("General.warningDataLoss")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary"
                            onClick={() => setShowCateogryConfirmation(false)}>{t("General.noOption")}</Button>
                    <Button variant="primary" onClick={() => handleConfirmCategory()}>{t("General.yesOption")}</Button>
                </Modal.Footer>
            </Modal>
            <OtherCorrelatedEntitiesModal
                entity={selectedEntity}
                setSelectedEntity={setSelectedEntity}
                otherCorrelatedEntities={BUYS.newBuys?.otherCorrelatedEntities || []}
                setOtherCorrelatedEntities={(arr) => dispatch(setNewBuys({...BUYS.newBuys, otherCorrelatedEntities: arr}))}
            />
        </div>
    )
}

export default BuysNew;
